import React from 'react'
import './Hero.css'

const Hero = () => {
  return (
    <div className='hero'>
        <div className='content'>
            <p>Transform your operational data</p>
            <p>into actionable growth with</p>
            <p>our integrated ecosystem</p>
            <form><button className='button' formAction='/contact'>Request A Free Demo</button></form>
        </div>
    </div>
  )
}

export default Hero